import { Clima } from '../../service/clima';
import RainChart from '../WeatherChart/rain';
import { Temperature } from '../WeatherChart/temperature';
import { WindSpeed } from '../WeatherChart/wind-speed';
import { WeatherSummary } from './summary';
import './WeatherForecast.css';

interface Props {
  persistedWeatherData: Clima;
  globalScales: GlobalScales;
}

export function ChartDesktop({ persistedWeatherData, globalScales }: Props) {
  return (
    <div className="d-none d-lg-block">
      <div className="row gx-3 gy-3 align-items-stretch">
        <div className="col-6">
          <h5 className="text-center mb-3 subtitle">Previsão para hoje</h5>
          <WeatherSummary
            weather={persistedWeatherData.hoje}
            units={persistedWeatherData.unidades}
          />
        </div>
        <div className="col-6">
          <h5 className="text-center mb-3 subtitle">Previsão para amanhã</h5>
          <WeatherSummary
            weather={persistedWeatherData.amanha}
            units={persistedWeatherData.unidades}
          />
        </div>
      </div>

      <div className="row gx-3 gy-3">
        <div className="col-12">
          <h6 className="text-center title_chart">
            Temperatura ({persistedWeatherData.unidades.temperatura})
          </h6>
        </div>

        <div className="col-6">
          <Temperature
            weather={persistedWeatherData.hoje}
            syncId="hoje_temp"
            globalMaxTemp={globalScales.temp}
          />
        </div>

        <div className="col-6">
          <Temperature
            weather={persistedWeatherData.amanha}
            syncId="amanha_temp"
            tomorrow
            globalMaxTemp={globalScales.temp}
          />
        </div>
      </div>

      <div className="row gx-3 gy-3">
        <div className="col-12">
          <h6 className="text-center title_chart">
            Chuva ({persistedWeatherData.unidades.precipitacao})
          </h6>
        </div>
        <div className="col-6">
          <RainChart
            weather={persistedWeatherData.hoje}
            globalMaxRain={globalScales.rain}
          />
        </div>
        <div className="col-6">
          <RainChart
            weather={persistedWeatherData.amanha}
            globalMaxRain={globalScales.rain}
          />
        </div>
      </div>

      <div className="row gx-3 gy-3">
        <div className="col-12">
          <h6 className="text-center title_chart">
            Velocidade do Vento ({persistedWeatherData.unidades.vento})
          </h6>
        </div>
        <div className="col-6">
          <WindSpeed
            weather={persistedWeatherData.hoje}
            syncId="hoje_wind"
            globalMaxWind={globalScales.wind}
          />
        </div>
        <div className="col-6">
          <WindSpeed
            weather={persistedWeatherData.amanha}
            syncId="amanha_wind"
            tomorrow
            globalMaxWind={globalScales.wind}
          />
        </div>
      </div>
    </div>
  );
}
